import { Factory } from 'rosie';

Factory.define('Floorboard').attr('name', 'FLOORBOARD');
